// Configure dayjs with required plugins for Ant Design
// This file must be imported before any Ant Design components
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
// Import all required plugins
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isToday from 'dayjs/plugin/isToday'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'

// Import locales
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-hk'

// Extend dayjs with all required plugins for Ant Design DatePicker
// Order matters - some plugins depend on others
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isToday)

// Map i18n language to dayjs locale
export const dayjsLocales: Record<string, string> = {
  'en-US': 'en',
  'zh-CN': 'zh-cn',
  'zh-HK': 'zh-hk',
}

export function setDayjsLocale(lang: string) {
  dayjs.locale(dayjsLocales[lang] || 'en')
}

// Export the configured dayjs instance
export { dayjs }
